import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface PrivateRouteProps {
    children: React.ReactNode
}

export function PrivateRoute({ children }: PrivateRouteProps) {
    const { user, isLoading } = useAuth()

    if (isLoading) {
        return <div>Loading...</div>
    }

    if (!user) {
        return <Navigate to="/login" replace />
    }

    return <>{children}</>
} 